import { render } from "./CalendarCard.vue?vue&type=template&id=36632155"
import script from "./CalendarCard.vue?vue&type=script&lang=js"
export * from "./CalendarCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__